const FooterComponent = () => {
  return <footer className="footer">&copy; 2023 Aine Media LLC</footer>;
};

export default FooterComponent;
